import { createSlice } from '@reduxjs/toolkit'

const getInitialCartState = () => {
    const cartList = localStorage.getItem('cartList');
    return cartList ? JSON.parse(cartList) : [];
};

const initialState = getInitialCartState();

const findExistingItem = (state, id) => {
    return state.findIndex((item) => item.product_id === id);
};

const findExistingVariant = (state, id) => {
    return state.findIndex((item) => item.product_variant_id === id)
}

export const CartSlice = createSlice({
    name: 'Cart',
    initialState: initialState,
    reducers: {
        addToCart: (state, action) => {
            const { product_id, product_variant_id, quantity = 1 } = action.payload;
            const existingItem = findExistingItem(state, product_id)
            const existingVariant = findExistingVariant(state, product_variant_id)
            if (existingItem !== -1 && existingVariant !== -1) {
                state[existingVariant].quantity += Number(quantity)
            } else {
                const futureTimeInMilliseconds = Date.now() + 4 * 60 * 60 * 1000;
                state.push({
                    ...action.payload,
                    quantity: Number(quantity),
                    expiresAt: futureTimeInMilliseconds
                })
            }
        },
        increaseQuantity: (state, action) => {
            const existingItem = findExistingItem(state, action.payload.product_id)
            const existingVariant = findExistingVariant(state, action.payload.product_variant_id)
            if (existingItem !== -1 && existingVariant !== -1) {
                state[existingVariant].quantity += 1
            }
        },
        decreaseQuantity: (state, action) => {
            const existingItem = findExistingItem(state, action.payload.product_id)
            const existingVariant = findExistingVariant(state, action.payload.product_variant_id)
            if (existingItem !== -1 && existingVariant !== -1) {
                state[existingVariant].quantity -= 1
            }
        },
        removeCartItem: (state, action) => {
            const existingVariant = findExistingVariant(state, action.payload)

            if (existingVariant !== -1) {
                const data = state.filter((item) => item.product_variant_id !== action.payload)
                return data
            }
        },
        clearCartItem: (state, action) => {
            return state = []
        }

    },
})

export const { addToCart, increaseQuantity, decreaseQuantity, removeCartItem, clearCartItem } = CartSlice.actions

export default CartSlice.reducer